/* import __COLOCATED_TEMPLATE__ from './escalate-to-human-conversation-item.hbs'; */
/* RESPONSIBLE TEAM: team-fin-voice */
import Component from '@glimmer/component';
import type { FormattedConversationEscalateToHuman } from '../conversation-item';
import { inject as service } from '@ember/service';
import type IntlService from 'ember-intl/services/intl';

export interface ConversationArgs {
  conversationItem: FormattedConversationEscalateToHuman;
  verboseLogsEnabled: boolean;
}

interface Signature {
  Args: ConversationArgs;
  Element: HTMLElement;
}

export default class EscalateToHumanConversationItem extends Component<Signature> {
  @service declare intl: IntlService;

  get formattedTitle() {
    return this.intl.t('ai-agent.voice-playground.conversation.escalate-to-human.title');
  }

  get formattedEscalationContext() {
    return this.args.conversationItem.escalationContext;
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'AiAgent::VoicePlayground::ConversationItems::EscalateToHumanConversationItem': typeof EscalateToHumanConversationItem;
  }
}
